export default "__VITE_ASSET__Z$YDs1PW__"